import React from 'react'

export default () => (
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8 6.78148L1.53432 0L0 1.60926L8 10L16 1.60926L14.4657 0L8 6.78148Z" fill="currentColor"/>
  </svg>

)
